import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x.svg'


const _hoisted_1 = {
  "data-testid": "tariff-rates-check-panel-detail",
  class: "font-montserrat text-10px md:text-12px xxl:text-14px"
}
const _hoisted_2 = { class: "justify-end items-center flex overflow-hidden fixed inset-0 z-40 outline-none focus:outline-none" }
const _hoisted_3 = {
  key: 1,
  class: "relative w-9/12 md:w-5/12 h-screen flex flex-col justify-between bg-white"
}
const _hoisted_4 = { class: "px-8 inline-flex justify-between w-full" }
const _hoisted_5 = { class: "font-semibold text-20px mr-4" }
const _hoisted_6 = { class: "px-4 py-2 overflow-auto h-screen" }
const _hoisted_7 = { class: "px-4 pt-2" }
const _hoisted_8 = { class: "flex flex-row my-4" }
const _hoisted_9 = { class: "w-1/2 flex flex-col" }
const _hoisted_10 = { class: "font-semibold text-gray-lp-300" }
const _hoisted_11 = { class: "my-2 mr-4 text-red-lp-100 font-normal" }
const _hoisted_12 = { class: "flex flex-row my-4" }
const _hoisted_13 = { class: "w-1/2 flex flex-col" }
const _hoisted_14 = { class: "font-semibold text-gray-lp-300" }
const _hoisted_15 = { class: "flex" }
const _hoisted_16 = { class: "my-2 mr-4 text-gray-lp-300 px-2 inline-flex capitalize bg-gray-lp-200 rounded" }
const _hoisted_17 = { class: "w-1/2 flex flex-col" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300" }, "Client/Partner", -1)
const _hoisted_19 = { class: "flex" }
const _hoisted_20 = { class: "my-1 text-gray-lp-300 px-2 inline-flex capitalize bg-gray-lp-200 rounded" }
const _hoisted_21 = { class: "flex flex-row my-4" }
const _hoisted_22 = { class: "w-1/2 flex flex-col" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300" }, "Base Rate", -1)
const _hoisted_24 = { class: "my-2 mr-4 text-gray-lp-300" }
const _hoisted_25 = { class: "w-1/2 flex flex-col" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300" }, " Heavyweight Surcharge ", -1)
const _hoisted_27 = {
  key: 0,
  class: "flex flex-row"
}
const _hoisted_28 = { class: "my-2 text-gray-lp-600" }
const _hoisted_29 = { class: "my-2 text-gray-lp-300 ml-2" }
const _hoisted_30 = {
  key: 1,
  class: "my-2 mr-4 text-gray-lp-300"
}
const _hoisted_31 = { class: "flex flex-row my-4" }
const _hoisted_32 = { class: "w-1/2 flex flex-col" }
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300" }, "Commodity Rate", -1)
const _hoisted_34 = {
  key: 0,
  class: "flex flex-row"
}
const _hoisted_35 = { class: "my-2 text-gray-lp-600" }
const _hoisted_36 = { class: "my-2 text-gray-lp-300 ml-2" }
const _hoisted_37 = {
  key: 1,
  class: "my-2 mr-4 text-gray-lp-300"
}
const _hoisted_38 = { class: "w-1/2 flex flex-col" }
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300" }, " Document Surcharge ", -1)
const _hoisted_40 = {
  key: 0,
  class: "flex flex-row"
}
const _hoisted_41 = { class: "my-2 text-gray-lp-600" }
const _hoisted_42 = { class: "my-2 text-gray-lp-300 ml-2" }
const _hoisted_43 = {
  key: 1,
  class: "my-2 mr-4 text-gray-lp-300"
}
const _hoisted_44 = /*#__PURE__*/_createVNode("div", { class: "border-b my-8" }, null, -1)
const _hoisted_45 = { class: "flex flex-row my-4" }
const _hoisted_46 = { class: "w-1/2 flex flex-col" }
const _hoisted_47 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300" }, " Origin Forward Rate ", -1)
const _hoisted_48 = {
  key: 0,
  class: "flex flex-row"
}
const _hoisted_49 = { class: "my-2 text-gray-lp-600" }
const _hoisted_50 = { class: "my-2 text-gray-lp-300 ml-2" }
const _hoisted_51 = {
  key: 1,
  class: "my-2 mr-4 text-gray-lp-300"
}
const _hoisted_52 = { class: "w-1/2 flex flex-col" }
const _hoisted_53 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300" }, "Publish Rate", -1)
const _hoisted_54 = {
  key: 0,
  class: "flex flex-row"
}
const _hoisted_55 = { class: "my-2 text-gray-lp-600" }
const _hoisted_56 = { class: "my-2 text-gray-lp-300 ml-2" }
const _hoisted_57 = {
  key: 1,
  class: "my-2 mr-4 text-gray-lp-300"
}
const _hoisted_58 = { class: "flex flex-row my-4" }
const _hoisted_59 = { class: "w-1/2 flex flex-col" }
const _hoisted_60 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300" }, " Shipping Surcharge ", -1)
const _hoisted_61 = {
  key: 0,
  class: "flex flex-row"
}
const _hoisted_62 = { class: "my-2 text-gray-lp-600" }
const _hoisted_63 = { class: "my-2 text-gray-lp-300 ml-2" }
const _hoisted_64 = {
  key: 1,
  class: "my-2 mr-4 text-gray-lp-300"
}
const _hoisted_65 = { class: "w-1/2 flex flex-col" }
const _hoisted_66 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300" }, " Destination Forward Rate ", -1)
const _hoisted_67 = {
  key: 0,
  class: "flex flex-row"
}
const _hoisted_68 = { class: "my-2 text-gray-lp-600" }
const _hoisted_69 = { class: "my-2 text-gray-lp-300 ml-2" }
const _hoisted_70 = {
  key: 1,
  class: "my-2 mr-4 text-gray-lp-300"
}
const _hoisted_71 = /*#__PURE__*/_createVNode("div", { class: "border-b my-8" }, null, -1)
const _hoisted_72 = {
  class: "flex flex-row my-4",
  "data-testid": "tariff-rates-check-detail-total-tariff"
}
const _hoisted_73 = { class: "w-1/2 flex flex-col" }
const _hoisted_74 = { class: "font-semibold text-gray-lp-300" }
const _hoisted_75 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_76 = { class: "mt-2 mr-4 text-14px text-gray-lp-600 font-medium" }
const _hoisted_77 = { class: "mr-4 text-20px text-red-lp-100 font-medium" }
const _hoisted_78 = {
  key: 1,
  class: "my-2 mr-4 text-20px text-red-lp-100 font-medium"
}
const _hoisted_79 = {
  key: 2,
  class: "flex flex-row"
}
const _hoisted_80 = {
  key: 0,
  class: " text-red-lp-300 text-16px bold mx-1"
}
const _hoisted_81 = { class: "text-12px" }
const _hoisted_82 = { class: "w-1/2 flex flex-col" }
const _hoisted_83 = { class: "font-semibold text-gray-lp-300" }
const _hoisted_84 = { class: "my-2 mr-4 text-gray-lp-600 text-20px flex flex-row items-center" }
const _hoisted_85 = { class: "relative" }
const _hoisted_86 = { class: "text-black-lp-300 w-full flex flex-col text-12px" }
const _hoisted_87 = { class: "py-2 text-gray-lp-300 font-normal text-center font-montserrat" }
const _hoisted_88 = { class: "mt-10" }
const _hoisted_89 = /*#__PURE__*/_createVNode("div", { class: "opacity-50 fixed inset-0 z-30 bg-black" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_detail = _resolveComponent("loading-detail")!
  const _component_OtopackWarning = _resolveComponent("OtopackWarning")!
  const _component_EmbargoWarning = _resolveComponent("EmbargoWarning")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_loading_detail, {
            key: 0,
            onClose: _ctx.onClose
          }, null, 8, ["onClose"]))
        : (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("div", {
              class: ["border-b border-gray-lp-400 pb-4", `${ _ctx.isIOSPlatform ? 'pt-12' : 'pt-10'}`]
            }, [
              _createVNode("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, _toDisplayString(_ctx.isAccountCountryOutsideID ? 'Rates Detail' : 'Detail Tarif'), 1),
                _createVNode("img", {
                  src: _imports_0,
                  class: "w-4 cursor-pointer",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args))),
                  alt: "x"
                })
              ])
            ], 2),
            _createVNode("div", _hoisted_6, [
              (_ctx.isAnyOtopack)
                ? (_openBlock(), _createBlock(_component_OtopackWarning, {
                    key: 0,
                    isDetail: true,
                    isNotAllProduct: _ctx.isNotAllProduct
                  }, null, 8, ["isNotAllProduct"]))
                : _createCommentVNode("", true),
              (_ctx.isAnyEmbargo)
                ? (_openBlock(), _createBlock(_component_EmbargoWarning, {
                    key: 1,
                    isDetail: true,
                    isFullEmbargo: _ctx.isFullEmbargo
                  }, null, 8, ["isFullEmbargo"]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _createVNode("div", _hoisted_9, [
                    _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('shipmentRates.detailRates.product')), 1),
                    _createVNode("div", _hoisted_11, _toDisplayString(_ctx.detailData?.productType), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode("div", _hoisted_13, [
                    _createVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('shipmentRates.detailRates.commodity')), 1),
                    _createVNode("div", _hoisted_15, [
                      _createVNode("div", _hoisted_16, _toDisplayString(_ctx.detailData?.commodityName === "Default"
                        ? "All Commodity"
                        : _ctx.isAccountCountryOutsideID || _ctx.isInternalOutsideID  ? _ctx.detailData.commodityNameEn : _ctx.detailData?.commodityName), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createVNode("div", _hoisted_19, [
                      _createVNode("div", _hoisted_20, _toDisplayString(_ctx.detailData?.accountRefName === ""
                        ? "Retail"
                        : _ctx.detailData?.accountRefName), 1)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_21, [
                  _createVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createVNode("div", _hoisted_24, _toDisplayString(_ctx.formatPrice(_ctx.detailData?.baseRate)), 1)
                  ]),
                  _createVNode("div", _hoisted_25, [
                    _hoisted_26,
                    (_ctx.detailData?.isPromo && _ctx.detailData?.heavyWeightSurcharge && _ctx.quantifiers('total_tariff'))
                      ? (_openBlock(), _createBlock("div", _hoisted_27, [
                          _createVNode("div", _hoisted_28, [
                            _createVNode("s", null, _toDisplayString(_ctx.formatPrice(_ctx.detailData?.heavyWeightSurcharge)), 1)
                          ]),
                          _createVNode("div", _hoisted_29, _toDisplayString(_ctx.formatPrice(_ctx.detailData?.heavyWeightSurchargeAfterDiscount)), 1)
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_30, _toDisplayString(_ctx.formatPrice(_ctx.detailData?.heavyWeightSurcharge)), 1))
                  ])
                ]),
                _createVNode("div", _hoisted_31, [
                  _createVNode("div", _hoisted_32, [
                    _hoisted_33,
                    (_ctx.detailData?.isPromo && _ctx.detailData?.commodityRate && _ctx.quantifiers('total_tariff'))
                      ? (_openBlock(), _createBlock("div", _hoisted_34, [
                          _createVNode("div", _hoisted_35, [
                            _createVNode("s", null, _toDisplayString(_ctx.formatPrice(_ctx.detailData?.commodityRate)), 1)
                          ]),
                          _createVNode("div", _hoisted_36, _toDisplayString(_ctx.formatPrice(_ctx.detailData?.commoditySurchargeAfterDiscount)), 1)
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_37, _toDisplayString(_ctx.formatPrice(_ctx.detailData?.commodityRate)), 1))
                  ]),
                  _createVNode("div", _hoisted_38, [
                    _hoisted_39,
                    (_ctx.detailData?.isPromo && _ctx.detailData?.documentSurcharge && _ctx.quantifiers('total_tariff'))
                      ? (_openBlock(), _createBlock("div", _hoisted_40, [
                          _createVNode("div", _hoisted_41, [
                            _createVNode("s", null, _toDisplayString(_ctx.formatPrice(_ctx.detailData?.documentSurcharge)), 1)
                          ]),
                          _createVNode("div", _hoisted_42, _toDisplayString(_ctx.formatPrice(_ctx.detailData?.documentSurchargeAfterDiscount)), 1)
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_43, _toDisplayString(_ctx.formatPrice(_ctx.detailData?.documentSurcharge)), 1))
                  ])
                ]),
                _hoisted_44,
                _createVNode("div", _hoisted_45, [
                  _createVNode("div", _hoisted_46, [
                    _hoisted_47,
                    (_ctx.detailData?.isPromo && _ctx.detailData?.originDistrictRate && (_ctx.quantifiers('total_tariff') || _ctx.quantifiers('origin_forward_rate')))
                      ? (_openBlock(), _createBlock("div", _hoisted_48, [
                          _createVNode("div", _hoisted_49, [
                            _createVNode("s", null, _toDisplayString(_ctx.formatPrice(_ctx.detailData?.originDistrictRate)), 1)
                          ]),
                          _createVNode("div", _hoisted_50, _toDisplayString(_ctx.formatPrice(_ctx.detailData?.originDistrictRateAfterDiscount)), 1)
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_51, _toDisplayString(_ctx.formatPrice(_ctx.detailData?.originDistrictRate)), 1))
                  ]),
                  _createVNode("div", _hoisted_52, [
                    _hoisted_53,
                    (_ctx.detailData?.isPromo && _ctx.detailData?.publishRate && (_ctx.quantifiers('total_tariff') || _ctx.quantifiers('publish_rate')))
                      ? (_openBlock(), _createBlock("div", _hoisted_54, [
                          _createVNode("div", _hoisted_55, [
                            _createVNode("s", null, _toDisplayString(_ctx.formatPrice(_ctx.detailData?.publishRate)), 1)
                          ]),
                          _createVNode("div", _hoisted_56, _toDisplayString(_ctx.formatPrice(_ctx.detailData?.publishRateAfterDiscount)), 1)
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_57, _toDisplayString(_ctx.formatPrice(_ctx.detailData?.publishRate)), 1))
                  ])
                ]),
                _createVNode("div", _hoisted_58, [
                  _createVNode("div", _hoisted_59, [
                    _hoisted_60,
                    (
                    _ctx.detailData?.isPromo && _ctx.detailData?.shippingSurchargeRate && (_ctx.quantifiers('total_tariff') || _ctx.quantifiers('shipping_surcharge'))
                  )
                      ? (_openBlock(), _createBlock("div", _hoisted_61, [
                          _createVNode("div", _hoisted_62, [
                            _createVNode("s", null, _toDisplayString(_ctx.formatPrice(_ctx.detailData?.shippingSurchargeRate)), 1)
                          ]),
                          _createVNode("div", _hoisted_63, _toDisplayString(_ctx.formatPrice(
                        _ctx.detailData?.shippingSurchargeRateAfterDiscount
                      )), 1)
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_64, _toDisplayString(_ctx.formatPrice(_ctx.detailData?.shippingSurchargeRate)), 1))
                  ]),
                  _createVNode("div", _hoisted_65, [
                    _hoisted_66,
                    (
                    _ctx.detailData?.isPromo && _ctx.detailData?.destinationDistrictRate && (_ctx.quantifiers('total_tariff') || _ctx.quantifiers('destination_forward_rate'))
                  )
                      ? (_openBlock(), _createBlock("div", _hoisted_67, [
                          _createVNode("div", _hoisted_68, [
                            _createVNode("s", null, _toDisplayString(_ctx.formatPrice(_ctx.detailData?.destinationDistrictRate)), 1)
                          ]),
                          _createVNode("div", _hoisted_69, _toDisplayString(_ctx.formatPrice(
                        _ctx.detailData?.destinationDistrictRateAfterDiscount
                      )), 1)
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_70, _toDisplayString(_ctx.formatPrice(_ctx.detailData?.destinationDistrictRate)), 1))
                  ])
                ]),
                _hoisted_71,
                _createVNode("div", _hoisted_72, [
                  _createVNode("div", _hoisted_73, [
                    _createVNode("div", _hoisted_74, _toDisplayString(_ctx.$t('shipmentRates.detailRates.shipmentRates')), 1),
                    (_ctx.detailData?.isPromo)
                      ? (_openBlock(), _createBlock("div", _hoisted_75, [
                          _createVNode("div", _hoisted_76, [
                            _createVNode("s", null, _toDisplayString(_ctx.formatPrice(_ctx.detailData?.totalTariff)), 1)
                          ]),
                          _createVNode("div", _hoisted_77, _toDisplayString(_ctx.formatPrice(_ctx.detailData?.totalTariffAfterDiscount)), 1)
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_78, _toDisplayString(_ctx.formatPrice(_ctx.detailData?.totalTariff)), 1)),
                    (_ctx.detailData?.isPromo && !_ctx.isSenderAccount)
                      ? (_openBlock(), _createBlock("div", _hoisted_79, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailData?.listDiscount, (promo, index) => {
                            return (_openBlock(), _createBlock("div", {
                              key: index,
                              class: "flex"
                            }, [
                              _createVNode("div", {
                                class: "flex flex-row items-center bg-green-lp-700 text-white text-10px px-1 rounded-md mb-1 cursor-pointer",
                                onMouseenter: ($event: any) => (_ctx.onOpenTooltipPromo($event, index)),
                                onMouseleave: ($event: any) => (_ctx.onOpenTooltipPromo($event, index))
                              }, [
                                _createVNode("p", null, _toDisplayString(promo.pdcPromoDiscount) + "% off", 1),
                                _createVNode(_component_Icons, {
                                  name: "info",
                                  class: "w-3 ml-1"
                                })
                              ], 40, ["onMouseenter", "onMouseleave"]),
                              (index !== _ctx.detailData?.listDiscount.length - 1 && _ctx.detailData?.listDiscount.length > 1)
                                ? (_openBlock(), _createBlock("span", _hoisted_80, "+"))
                                : _createCommentVNode("", true),
                              _createVNode(_component_OverlayPanel, {
                                ref: `infoPromo${index}`,
                                appendTo: "body",
                                class: "text-center",
                                style: {"width":"200px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode("p", _hoisted_81, _toDisplayString(promo.pdcName) + " " + _toDisplayString(_ctx.$t('shipmentRates.until')) + " " + _toDisplayString(_ctx.formatDateWithoutTime(promo.pdcEndDate)), 1)
                                ]),
                                _: 2
                              }, 1536)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_82, [
                    _createVNode("div", _hoisted_83, _toDisplayString(_ctx.$t('shipmentRates.detailRates.shipmentTime')), 1),
                    _createVNode("div", _hoisted_84, [
                      _createTextVNode(_toDisplayString(_ctx.isAccountCountryOutsideID ? _ctx.detailData?.sla.replace('Hari', "Days") : _ctx.detailData?.sla) + " ", 1),
                      _withDirectives(_createVNode("div", _hoisted_85, [
                        _createVNode("img", {
                          src: 
                        require(`@/app/ui/assets/svg/${
                          _ctx.isActiveTooltip ? 'info-red' : 'info'
                        }.svg`)
                      ,
                          class: "ml-1 h-4 xxl:h-5 cursor-pointer",
                          onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleTooltip($event))),
                          onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleTooltip($event))),
                          alt: "info"
                        }, null, 40, ["src"]),
                        _createVNode(_component_OverlayPanel, {
                          class: _ctx.detailData?.sla !== '-' ? 'check-tarif-op' : '',
                          ref: "opTooltip",
                          appendTo: "body"
                        }, {
                          default: _withCtx(() => [
                            _createVNode("div", _hoisted_86, [
                              _withDirectives(_createVNode("div", _hoisted_87, null, 512), [
                                [_directive_sanitize_html, _ctx.$t('shipmentRates.tooltipSLA')]
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ], 512), [
                        [_vShow, _ctx.detailData?.sla && _ctx.detailData?.sla !== '-']
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_88, [
                  (_ctx.isBookingAble && _ctx.isShowButton)
                    ? (_openBlock(), _createBlock(_component_button_fill, {
                        key: 0,
                        title: _ctx.isAccountCountryOutsideID ? '+ Booking Shipment' : _ctx.titleButton,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToBook(this.detailData))),
                        class: "bg-red-lp-300",
                        isDisabled: _ctx.detailData?.isEmbargo
                      }, null, 8, ["title", "isDisabled"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
    ]),
    _hoisted_89
  ]))
}